module.exports = __webpack_public_path__ + "img/communication.bda01874.png";